module.exports = __webpack_public_path__ + "img/1.f60eb481.png";